export default __webpack_public_path__ + "4c69ee526d4d557addfa921166aceca7.png";